<template>
  <div class="wrapper">
    <Menu />
    <Header hideMore title="Anadolu Efes Fan Club Kampanyaları" />
    <div class="body-area pt70">
      <div class="container-fluid">
        <div class="row">
          <div
            class="col-12 p-0"
            v-for="item in $store.state.campaigns"
            :key="item.id"
            @click="$router.push({name: 'FanClubDetail', params: {data: item, slug: item.id}})"
          >
            <div class="item-box">
              <div class="box-header p-0">
                <img :src="item.image" class="w-100" />
              </div>
              <div class="box-title p-0">
                <h1 class="fc-2 fs-20 bb-1 p-g">{{ item.name }}</h1>
                <div class="col-12">
                  <h2 class="fc-1 fs-14 pt-2 pb-2">
                    <img src="/static/img/arrow-left.svg" class="mr-2" />
                    Kampanya Detayı
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
export default {
  name: "FanClub",
  components: {
    Footer,
    Menu,
    Header
  },
  beforeMount() {
    axios.post("kampanya/liste").then(res => {
      this.$store.state.campaigns = res.data.data;
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/FanClub.vue